import PropTypes from 'prop-types';
export default PropTypes.shape({
  offsetX: PropTypes.number,
  offsetY: PropTypes.number,
  width: PropTypes.number,
  height: PropTypes.number
});